<div class="toast-stack" aria-live="polite">
  <div
    class="toast-item"
    *ngFor="let toast of notificationService.toasts; trackBy: trackByToastId"
    [ngClass]="'toast-item--' + toast.type"
  >
    <span class="toast-item__message">{{ toast.message }}</span>
    <button
      type="button"
      class="toast-item__dismiss"
      (click)="notificationService.dismissToast(toast.id)"
      aria-label="Dismiss"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
